import { useMutation } from "@tanstack/react-query";
import apiDal from "../config/apiDal";

type SubmitReportPayload = {
	[key: string]: any;
};

const submitReport = async (report: SubmitReportPayload): Promise<any> => {
	const response = await apiDal.post("/findreport/new", report);
	return response.data;
};

export const useSubmitReport = () => {
	return useMutation({
		mutationFn: submitReport,
	});
};
